"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useUpsell2 = _interopRequireDefault(require("../../hooks/upsell/useUpsell"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _UpsellCardFactory = _interopRequireDefault(require("./UpsellCardFactory"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CardContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var CardContainerTest = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex !important;\n  flex-direction: column;\n  height: 100%;\n"])));
var UpsellCategoryDisplay = function UpsellCategoryDisplay() {
  var _useUpsell = (0, _useUpsell2.default)(),
    relationshipOfferingGroups = _useUpsell.relationshipOfferingGroups,
    onUpsellProductAdd = _useUpsell.onUpsellProductAdd,
    onUpsellProductRemove = _useUpsell.onUpsellProductRemove,
    isDisabled = _useUpsell.isDisabled;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, relationshipOfferingGroups.map(function (group, index) {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 3,
        bottom: 5
      },
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      level: 4,
      weight: 3
    }, _services.locale.localeString("RelationshipOffer.".concat(group.groupName))), /*#__PURE__*/_react.default.createElement(CardContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CardCarousel, {
      allowOverflow: true,
      slidesToShow: {
        xl: 2,
        sm: 1
      },
      slidesToScroll: {
        xl: 1
      },
      id: "".concat(group.groupName, "-carousel")
    }, group.products.map(function (mainUpsellOffering, index) {
      var _group$selectedProduc;
      var isSelected = (_group$selectedProduc = group.selectedProducts) === null || _group$selectedProduc === void 0 ? void 0 : _group$selectedProduc.includes(mainUpsellOffering.id);
      return /*#__PURE__*/_react.default.createElement(CardContainerTest, {
        key: mainUpsellOffering.id
      }, /*#__PURE__*/_react.default.createElement(_UpsellCardFactory.default, {
        product: mainUpsellOffering,
        index: index,
        onAddToCart: onUpsellProductAdd,
        onRemoveFromCart: onUpsellProductRemove,
        isDisabled: isDisabled(group.groupName, mainUpsellOffering.id),
        isSelected: isSelected
      }));
    }))));
  }));
};
var _default = UpsellCategoryDisplay;
exports.default = _default;